/*
  Which EA FC edition this build serves, and where it reads artwork from.

  Set at build time so one codebase produces both the FC 26 and FC 27 bundles.
*/

/** What users read: "FC 26", "FC 27". */
export const GAME_NAME: string = import.meta.env.VITE_APP_GAME_NAME || "FC 27";

/*
  Asset-CDN folder for per-game artwork — players, clubs, countries, leagues,
  playercards, cards, sbcs, packs. Those folders exist per game (/fc25/ and
  /fc26/ both resolve), but they are populated over time, so this stays on fc26
  until the fc27 upload is actually complete. Flip it deliberately; don't tie it
  to GAME_NAME.
*/
export const GAME_ASSET_SLUG: string =
  import.meta.env.VITE_APP_GAME_ASSET_SLUG || "fc27";

/*
  Asset-CDN folder for artwork that is never republished per game — banners,
  page-headers, evolutions-hub, tmp/*. Probed 2026-08-19: these exist only under
  /fc26/ and have no /fc25/ equivalent, so they are pinned rather than versioned.

  Not configurable on purpose. If FC 27 artwork does get published under /fc27/,
  that's new components with new paths, not a repoint of the FC 26 TOTS and FUT
  Birthday banners.
*/
export const PINNED_ASSET_SLUG = "fc26";

/*
  Route prefix this build is mounted under: "" for the root deploy, "/fc27" for
  the staged FC 27 deploy behind the CloudFront /fc27/* behavior. Must match the
  router basename and the Vite base.
*/
export const ROUTE_BASE: string = (
  import.meta.env.VITE_APP_ROUTE_BASE || ""
).replace(/\/+$/, "");

/*
  Which edition is "the game" right now, and where each edition lives. Rotate
  these four literals once per cycle. Route base cannot identify the edition:
  the root FC 27 deploy and the fc26.easysbc.io archive both build with an
  empty ROUTE_BASE, so identity comes from GAME_NAME.
*/
const CURRENT_EDITION_NAME = "FC 27";
const CURRENT_EDITION_URL = "https://www.easysbc.io/";
const ARCHIVE_EDITION_NAME = "FC 26";
const ARCHIVE_EDITION_URL = "https://fc26.easysbc.io/";

/** True in a frozen old-edition deploy (fc26.easysbc.io). */
export const IS_ARCHIVE_EDITION: boolean = GAME_NAME !== CURRENT_EDITION_NAME;

/** EA's per-card PlayStyle+ cap. FC 27 dropped it from five to three. */
export const PLAYSTYLES_PLUS_CAP: number = IS_ARCHIVE_EDITION ? 5 : 3;

/** The other deploy — the one this build's banners link to. */
export const OTHER_EDITION_NAME = IS_ARCHIVE_EDITION
  ? CURRENT_EDITION_NAME
  : ARCHIVE_EDITION_NAME;
export const OTHER_EDITION_URL = IS_ARCHIVE_EDITION
  ? CURRENT_EDITION_URL
  : ARCHIVE_EDITION_URL;

/*
  The club-import tutorial on the other deploy. Must be a plain <a> and a full
  page load: a react-router navigation stays in this build and 404s.
*/
export const OTHER_EDITION_TUTORIAL_URL = `${OTHER_EDITION_URL}club-import-tutorial`;

/*
  Whether this build advertises the FC 27 deploy — the nav banner and the front
  page panel. Off until the data is real and the backend behind /fc27 can carry
  reveal-day traffic; the two banners are the only thing on the root deploy that
  links there, so this is the announcement.

  Separate from the deploy itself on purpose: the code can ship, and CloudFront
  can be configured, without either being visible to anyone.
*/
export const SHOW_FC27_PROMO: boolean =
  import.meta.env.VITE_APP_SHOW_FC27_PROMO === "true";
